import React from "react";
import { Box, Stack, useTheme } from "@mui/material";

import Typography from "components/basic/typography";
import Badge from "components/basic/badge";

import { EVENT_TYPE_MAP } from "../../../../../eventTypes";
import { meetingStatusMeta } from "../../helpers/meetingStatus";
import { Booking } from "../../../../types";

const TitleCard: React.FC<{ booking: Booking }> = ({ booking }) => {
  const theme = useTheme();
  const meta = EVENT_TYPE_MAP[booking.type];
  const Icon = meta.icon;
  const statusInfo = meetingStatusMeta(booking, theme);

  return (
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      sx={{
        borderLeft: `4px solid ${meta.color}`,
        backgroundColor: `${meta.color}1A`,
        borderRadius: 1,
        p: 1.5,
        mb: 2,
      }}
    >
      <Icon sx={{ color: meta.color }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body1" style={{ fontWeight: 600 }}>
          {booking.title}
        </Typography>
        <Typography
          variant="caption"
          style={{ color: theme.palette.text.secondary }}
        >
          {meta.label}
        </Typography>
      </Box>
      {statusInfo && (
        <Box sx={{ flexShrink: 0 }}>
          <Badge
            label={statusInfo.label}
            color={statusInfo.color}
            icon={
              <statusInfo.Icon sx={{ fontSize: 14, color: statusInfo.color }} />
            }
          />
        </Box>
      )}
    </Stack>
  );
};

export default TitleCard;
